import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the SettingProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class SettingProvider {

    constructor() {
        if (this.getSetting() == null) {
            this.setSetting({
                sGetNotif: true,
                acGetNotif: true,
                ispaGetNotif: true,
                atRepGetNotif: true,
                atGetNotif: true,
                Companies :[]
            });
        }
    }

    getSetting() { return JSON.parse(localStorage.getItem('Setting')); }
    setSetting(value) { localStorage.setItem('Setting', JSON.stringify(value)); }
    AddCompany(value) {
        if (this.CompanyIsSelected(value)) {
            return;
        }
        let Setting: any = this.getSetting();
        Setting.Companies.push(value);
        this.setSetting(Setting);
    }
    RemoveCompany(value) {
        let Setting: any = this.getSetting();
        for (var i = 0; i < Setting.Companies.length; i++) {
            if (Setting.Companies[i].Id == value.Id) {
                Setting.Companies.splice(i, 1);
                break;
            }
        }
        this.setSetting(Setting);
    }
    CompanyIsSelected(value) {
        let Setting: any = this.getSetting();
        for (var i = 0; i < Setting.Companies.length; i++) {
            if (Setting.Companies[i].Id == value.Id) {
                return true;
            }
        }
        return false;
    }
    GetIds() {
        var ids: string = '';
        let setting = this.getSetting();
        if (setting.acGetNotif) {
            ids += '20396,';
        }
        if (setting.ispaGetNotif) {
            ids += '20400,';
        }
        if (setting.atRepGetNotif) {
            ids += '20399,';
        }
        setting.Companies.forEach((value, index) => {
            ids += value.Id+",";
        })
        return ids;
    }
}



// WEBPACK FOOTER //
// ./src/providers/SettingProvider.ts